import { createFileRoute, useSearch } from '@tanstack/react-router'
import type { JSX } from 'react'

import { ReportDraftScreen } from './-components/report-draft-screen.tsx'

/**
 * Read the draft id out of the URL's search.
 *
 * Read loosely, as `readReportChatSearch` does, rather than through
 * `validateSearch`: a typed search on one route narrows the search type of
 * every `navigate` call in the app.
 *
 * @param search - The parsed search.
 * @returns The draft the URL names, or null.
 */
export function readReportDraftSearch(
  search: Record<string, unknown>
): string | null {
  return typeof search.id === 'string' && search.id !== '' ? search.id : null
}

export const Route = createFileRoute('/lab/report-draft')({
  component: ReportDraftPage
})

function ReportDraftPage(): JSX.Element {
  const search: Record<string, unknown> = useSearch({ strict: false })

  return <ReportDraftScreen draftId={readReportDraftSearch(search)} />
}
